import * as React from "react";
import { useRef } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import { HasOwnership } from "components/common";
function usePluggableEntitySharedActions(entity, entityType, onCloseModal = void 0) {
  const modalRefs = useRef({});
  const pluginActions = usePluginEntities("components.shared.entityActions");
  const availableActions = pluginActions.filter((action) => action.useCondition ? !!action.useCondition() : true);
  const actions = availableActions.map((action) => {
    const { key, component: PluggableEntityAction } = action;
    return /* @__PURE__ */ React.createElement(HasOwnership, { key: `entity-action-${key}`, id: entity == null ? void 0 : entity.id, type: entityType }, ({ disabled }) => disabled ? null : /* @__PURE__ */ React.createElement(
      PluggableEntityAction,
      {
        key: `entity-action-${key}`,
        entity,
        modalRef: () => modalRefs.current[key]
      }
    ));
  });
  const actionModals = availableActions.filter(({ modal }) => !!modal).map((action) => {
    const { key, modal: ActionModal } = action;
    return /* @__PURE__ */ React.createElement(
      ActionModal,
      {
        entity,
        entityType,
        onClose: onCloseModal,
        key: `entity-action-modal-${key}`,
        ref: (ref) => {
          modalRefs.current[key] = ref;
        }
      }
    );
  });
  return { actions, actionModals };
}
export default usePluggableEntitySharedActions;
